import { Component } from '@angular/core';
import html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-future-feature',
  templateUrl: './future-feature.component.html',
  styleUrls: ['./future-feature.component.scss']
})
export class FutureFeatureComponent {

  ngOnInit(): void {
    this.createPdf();
  }


  options = {
    margintosd: 12,
    margin: [20,24,20,24],
    filename: 'minuta.pdf',
    image: {
      type: 'jpeg',
      quality: '0.95',
    },
    pagebreak: { mode: 'avoid-all', after: '#finPage1, #finPage2, #finPage3' },

    html2canvas: {
      scale: 2,
      windowWidth: window.innerWidth, // Ancho total de la ventana
      windowHeight: window.innerHeight,
    },

    jsPDF: {
      unit: 'pt',
      format: 'letter',
      orientation: 'portrait',
    },
  };

  createPdf(): void {
    const element = document.getElementById('htmlData');
    if (!element) {
      console.error('Element with id "htmlData" not found!');
      return;
    }

    var pdfElements = document.querySelectorAll('.pdf-content');

    pdfElements.forEach(function(el) {
      el.classList.add('htmlData');
    });

    element.style.width = '100%';

    html2pdf()
      .from(element)
      .set(this.options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        // You can add extra pages if needed
        // pdf.addPage();
      })
      .set(this.options)
      .save("ProbandoPDF°")
      .finally(() => {
        // Mostrar las secciones ocultas después de generar el PDF
        document.querySelectorAll('.desc_line').forEach((el: HTMLElement) => {
          el.style.display = 'flex';
        });
        document.querySelectorAll('.page2').forEach((el: HTMLElement) => {
          el.style.pageBreakBefore = 'always';
        });

        pdfElements.forEach(function(el) {
          el.classList.remove('pdf-visible');
      });

      });
  }

}
